import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { Css, Responsive, UnstyledUl } from '../../../../ui';
import { NavListItem } from './NavItem.styles';

export const NavContainer = styled.nav<{ isSubmenuOpen: boolean }>`
	min-width: ${Css.pxToRem(630)};
	position: relative;
	padding: ${Css.pxToRem(24)} ${Css.pxToRem(40)};
	display: flex;
	flex-direction: row;
	align-items: center;
	pointer-events: all;
	border-radius: ${Css.pxToRem(8)};
	${({ isSubmenuOpen }) =>
		isSubmenuOpen &&
		css`
			background: ${Color.PrimaryWhite};
		`}

	@media (${Responsive.getMediaQueryForBreakpoint('13inch-navigation')}) {
		padding: ${Css.pxToRem(20)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		padding: ${Css.pxToRem(40)} ${Css.pxToRem(24)};
		width: 100vw;
		min-width: auto;
		height: 90%;
		overflow-x: hidden;
	}
`;

export const MobileNavListItem = styled(NavListItem)`
	color: ${Color.PrimaryBlueDark};
	font-size: ${Css.pxToRem(14)};
	font-weight: 700;
`;

export const ListContainer = styled(UnstyledUl)`
	display: flex;
	gap: ${Css.pxToRem(20)};
	align-items: flex-start;
	pointer-events: all;

	> li:last-child {
		button {
			border-radius: ${Css.pxToRem(10)} ${Css.pxToRem(10)} 0px
				${Css.pxToRem(10)};
		}
	}
	${MobileNavListItem} {
		display: none;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		width: 100%;
		height: 100%;
		flex-direction: column;
		align-items: flex-start;
		gap: ${Css.pxToRem(32)};
		${NavListItem} {
			pointer-events: all;
		}
		${MobileNavListItem} {
			display: flex;
		}
	}
`;
